import React from "react";
import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useState, useEffect } from "react";

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100); // Adjust 100 to your desired scroll threshold
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const whatsappUrl = "https://wa.me/6281932536022";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      <Card
        style={{ maxWidth: "300px", marginRight: "20px" }}
        className={`card-wa ${isVisible ? "visible" : "hidden"}`}
      >
        <Card.Body>
          <Card.Title style={{ fontSize: "18px !important" }}>
            Hi RPM !!
          </Card.Title>
          <Card.Text>Click untuk menghubungi lebih lanjut</Card.Text>
        </Card.Body>
      </Card>
      <Button
        variant="none"
        style={{
          height: "100%",
          borderRadius: "50%",
          backgroundColor: "#25d366",
        }}
        href={whatsappUrl}
        target="_blank"
      >
        <i
          className="bi bi-whatsapp"
          style={{ fontSize: "30px", borderRadius: "50%", color: "white" }}
        ></i>
      </Button>
    </div>
  );
};

export default WhatsAppButton;
